/**
 * scripts.js
 *
 * This is where you should write your custom javascript code
 */


$(function () {
    $('a[href*=\\#]').on('click', function (e) {
        e.preventDefault();
        $('html, body').animate({
            scrollTop: $($(this).attr('href')).offset().top
        }, 500, 'linear');
    });
});

// Material Contact Form Animation
$('#form').find('.form-control').each(function() {
  var targetItem = $(this).parent();
  if ($(this).val()) {
    $(targetItem).find('label').css({
      'top': '10px',
      'fontSize': '14px'
    });
  }
})
$('#form').find('.form-control').focus(function() {
  $(this).parent('.form-group').addClass('focus');
  $(this).parent().find('label').animate({
    'top': '10px',
    'fontSize': '14px'
  }, 200);
})
$('#form').find('.form-control').blur(function() {
  if ($(this).val().length == 0) {
    $(this).parent('.form-group').removeClass('focus');
    $(this).parent().find('label').animate({
      'top': '30px',
      'fontSize': '14px'
    }, 200);
  }
})

// Phone Number Mask
if (document.getElementById('phone')) {
    document.getElementById('phone').addEventListener('input', function (e) {
      var x = e.target.value.replace(/\D/g, '').match(/(\d{0,3})(\d{0,3})(\d{0,4})/);
      e.target.value = !x[2] ? x[1] : '(' + x[1] + ') ' + x[2] + (x[3] ? '-' + x[3] : '');
    });
}


// WEBPACK FOOTER //
// ./src/js/scripts.js